/**
 * Generated by orval v7.0.1 🍺
 * Do not edit manually.
 * API V5
 * OpenAPI spec version: v5
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import type {
  PostApiV5FirmsAppConnectionsSmartVaultClientsSynchronization202
} from '.././schemas'
import postApiV5FirmsAppConnectionsSmartVaultClientsSynchronizationMutator from '../../configOrvalAPIV5';
import type { ErrorType as PostApiV5FirmsAppConnectionsSmartVaultClientsSynchronizationErrorType } from '../../configOrvalAPIV5';



/**
 * @summary Kicks off a SmartVault account sync
 */
export const postApiV5FirmsAppConnectionsSmartVaultClientsSynchronization = (
    
 ) => {
      
      
      return postApiV5FirmsAppConnectionsSmartVaultClientsSynchronizationMutator<PostApiV5FirmsAppConnectionsSmartVaultClientsSynchronization202>(
      {url: `/api/v5/firms/app_connections/smart_vault/clients/synchronization`, method: 'POST'
    },
      );
    }
  


export const getPostApiV5FirmsAppConnectionsSmartVaultClientsSynchronizationMutationOptions = <TError = PostApiV5FirmsAppConnectionsSmartVaultClientsSynchronizationErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsAppConnectionsSmartVaultClientsSynchronization>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsAppConnectionsSmartVaultClientsSynchronization>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV5FirmsAppConnectionsSmartVaultClientsSynchronization>>, void> = () => {
          

          return  postApiV5FirmsAppConnectionsSmartVaultClientsSynchronization()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV5FirmsAppConnectionsSmartVaultClientsSynchronizationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV5FirmsAppConnectionsSmartVaultClientsSynchronization>>>
    
    export type PostApiV5FirmsAppConnectionsSmartVaultClientsSynchronizationMutationError = PostApiV5FirmsAppConnectionsSmartVaultClientsSynchronizationErrorType<unknown>

    /**
 * @summary Kicks off a SmartVault account sync
 */
export const usePostApiV5FirmsAppConnectionsSmartVaultClientsSynchronization = <TError = PostApiV5FirmsAppConnectionsSmartVaultClientsSynchronizationErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsAppConnectionsSmartVaultClientsSynchronization>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiV5FirmsAppConnectionsSmartVaultClientsSynchronization>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostApiV5FirmsAppConnectionsSmartVaultClientsSynchronizationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    